import { Injectable } from '@angular/core';

import { ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class VnaServiceService {

    constructor(private api: ApiService) {

    }

    findServicesByType(type: string): Observable<any> {
        return this.api.get('vna/service', { 'type' : type });
    }

    findService(pkService: number): Observable<any> {
        return this.api.get('vna/service/' + pkService);
    }


}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna_services/services/vna-service.service.ts